<template>
  <div>
    <b-card title="Payment Options">
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="filter"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table
            striped
            :items="countries"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template v-slot:cell(currencies)="data">
              <b-row>
                <b-col v-if="$can('AssignUnAssign', 'MerchantFOP')">
                  <span
                    v-for="currency in data.item.currencies"
                    :key="currency.id"
                  >
                    <b-badge variant="warning">{{
                      currency.currencyCode
                    }}</b-badge>
                    &nbsp;
                  </span>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(action)="data">
              <b-row>
                <b-col v-if="$can('AssignUnAssign', 'MerchantFOP')">
                  <b-button
                    variant="primary"
                    @click="assignCurrency(data.item.id, data.item.currencies)"
                  >
                    <span>Assign/UnAssign Currency</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ countries.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col>
            <div class="mt-3">
              Submitted Names:
              <div>
                --
                Name:{{ name }}
                code:{{ code }}
                country:{{ country }}
                provider:{{ provider }}
                type:{{ type }}
                instruction:{{ instruction }}
              </div>
            </div>
          </b-col> -->

        <b-modal
          id="modal-assigncurrency"
          title="Assign Currency"
          ok-title="submit"
          size="lg"
          cancel-variant="outline-secondary"
          @ok="submitAssignFops"
        >
          <b-form>
            <b-form-group label="Select Payment Options">
              <b-form-checkbox-group
                v-model="addCurrency.currencies"
                :options="assignCurrencies"
                switches
                stacked
              />
            </b-form-group>
            <!-- <h3>selected Merchant:{{ selectedMerchant }}</h3> -->
          </b-form>
        </b-modal>
      </b-row>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BAvatar,
  BBadge,
  BFormSelect,
  BForm,
  BLink,
  BCard,
  BOverlay,
  BDropdownItem,
  BDropdown,
  BButton,
  BFormGroup,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BAvatar,
    BBadge,
    BFormSelect,
    BLink,
    BCard,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BButton,
    BFormGroup,
    BFormCheckboxGroup,
    BForm,
  },
  data() {
    return {
      required,
      boolValue: null,
      isLoading: false,
      fields: ["countryName", "currencies", "action"],
      countries: [],
      addCurrency: {
        countryId: null,
        currencies: [],
      },
      filter: "",
      perPage: 10,
      currentPage: 1,
      name: "",
      code: "",
      country: "",
      provider: "1",
      type: "2",
      instruction: "",
      typeSelected: [],
      providerSelected: ["1"],
      typeOptions: [
        { value: "2", text: "Card" },
        { value: "3", text: "Mobile" },
        { value: "4", text: "Bank" },
      ],
      providerOptions: [
        { value: "1", text: "Amole" },
        { value: "2", text: "CBE" },
        { value: "3", text: "PSS" },
        { value: "4", text: "United" },
        { value: "5", text: "Abssinia" },
      ],
      houres: null,
      selectedFop: null,
      selectedFopId: null,
      assignCurrencies: [],
      selectedMerchantId: JSON.parse(localStorage.getItem("defaultMerchantId")),
      userRole: localStorage.getItem("userRole"),
    };
  },
  computed: {
    rows() {
      return this.countries.length;
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    // this.fetchData().catch(error => {
    //   console.error(error)
    // })
  },
  methods: {
    handleOk() {
      this.$bvModal.msgBoxConfirm(`Name:${this.name}`).then((value) => {
        this.boolValue = value;
      });
    },

    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "MerchantFOP-View");
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          console.log(res);
          this.countries = res.countries;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    assignCurrency(id, currencies) {
      this.assignCurrencies = [];
      this.addCurrency.currencies = [];
      this.addCurrency.countryId = null;

      this.isLoading = true;
      this.addCurrency.countryId = id;
      currencies.forEach((item) => {
        this.addCurrency.currencies.push(item.id);
      });
      this.$store.dispatch("config/getActionPrivilege", "CountryCurrency-View");
      axios
        .get(`/Currency/api/V1.0/Currency/GetAll`)
        .then((res) => {
          console.log(res);
          res.currencies.forEach((item) => {
            this.assignCurrencies.push({
              value: item.id,
              text: item.currencyCode,
            });
          });

          this.$bvModal.show("modal-assigncurrency");
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    submitAssignFops() {
      this.isLoading = true;
      axios
        .post("/Country/api/V1.0/Country/AddCurrency", this.addCurrency)
        .then((res) => {
          console.log(res);
          this.isLoading = false;
          this.$bvModal.msgBoxOk(`${res.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.fetchData();
        })
        .catch((res) => {
          this.isLoading = false;
          this.$bvModal.msgBoxOk(res.data.message, {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
        });
    },
    UnAssignPaymentOption(id, name) {
      this.$bvModal
        .msgBoxConfirm(` to UnAssign: ${name}`, {
          title: "Are You Sure",
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.isLoading = true;
            axios
              .put(
                "/PaymentOptions/api/V1.0/PaymentOptions/UnAssignPaymentOption",
                {
                  paymentOptionId: id,
                }
              )
              .then((res) => {
                this.isLoading = false;
                this.fetchData();
                this.$bvModal.msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              })
              .catch((res) => {
                this.isLoading = false;
                this.$bvModal.msgBoxOk(res.data.message, {
                  title: "Error",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              });
          }
        });
    },
  },
};
</script>
